import { AuthActions } from "../LoginRedux/Action";
import { newPickerActions } from "./Action";

const initialState = {
  newPickerOrderDetailsSuccess: null,
  newPickerOrderError: null,
  newScannedPickerOrderDetailsSuccess: null,
  newScannedPickerOrderError: null,
  missingMeds: null,
  missingMedsError: null,
  validateOrderError: null,
};

export const newPickerOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case newPickerActions.CLEAR_PICKER_ORDER_DATA:
      return {
        ...state,
        newPickerOrderDetailsSuccess: null,
        newPickerOrderError: null,
        newScannedPickerOrderDetailsSuccess: null,
        newScannedPickerOrderError: null,
        isLoading: true,
      };

    case newPickerActions.FETCH_PICKER_ORDER_DATA_SUCCESS:
      return {
        ...state,
        newPickerOrderDetailsSuccess: action.payload,
        newPickerOrderError: null,
        isLoading: false,
      };

    case newPickerActions.FETCH_PICKER_ORDER_DATA_FAILURE:
      return {
        ...state,
        newPickerOrderDetailsSuccess: null,
        newPickerOrderError: action.payload,
        isLoading: false,
      };

    case newPickerActions.FETCH_SCANNED_PICKER_ORDER_DATA_SUCCESS:
      return {
        ...state,
        newScannedPickerOrderDetailsSuccess: action.payload,
        newScannedPickerOrderError: null,
        isLoading: false,
      };

    case newPickerActions.FETCH_SCANNED_PICKER_ORDER_DATA_FAILURE:
      return {
        ...state,
        newScannedPickerOrderDetailsSuccess: null,
        newScannedPickerOrderError: action.payload,
        isLoading: false,
      };

    case newPickerActions.SAVE_MISSING_MEDS_SUCCESS:
      return {
        ...state,
        missingMeds: action.payload,
        missingMedsError: null,
        isLoading: false,
      };

    case newPickerActions.SAVE_MISSING_MEDS_FAILURE:
      return {
        ...state,
        missingMeds: null,
        missingMedsError: action.payload,
        isLoading: false,
      };

    // case newPickerActions.VALIDATE_ORDER_ASSIGN_PICKER_SUCCESS:
    //   return {
    //     ...state,
    //     validateOrderError: null,
    //   };

    // case newPickerActions.VALIDATE_ORDER_ASSIGN_PICKER_FAILURE:
    //   return {
    //     ...state,
    //     validateOrderError: action.payload,
    //   };

    default:
      return state;
  }
};
